import React, { useState } from "react";
import './VisaRequirementsPage.css'
import { Link } from "react-router-dom";
/** صفحة متطلبات التأشيرات – ستايل عام بلون البراند #b02d3b */
export default function VisaRequirementsPage() {
  const [openFaq, setOpenFaq] = useState(null);
  const toggle = (i) => setOpenFaq((prev) => (prev === i ? null : i));

  const checklist = [
    { title: "جواز سفر صالح", desc: "يُفضّل صلاحية 6–7 أشهر من تاريخ السفر مع صفحات فارغة كافية للختم." },
    { title: "صور شخصية", desc: "خلفية بيضاء، والمقاس يختلف حسب الجهة. تأكدي من الإضاءة ووضوح الوجه." },
    { title: "خطاب تعريف من العمل", desc: "بالإنجليزية غالبًا، يتضمن المسمى الوظيفي والراتب وتاريخ بدء العمل ومختوم." },
    { title: "كشف حساب بنكي", desc: "آخر 3 أشهر (أحيانًا 6)، بالإنجليزية ومختوم لإثبات الملاءة المالية." },
    { title: "تأمين سفر/طبي", desc: "يغطي كامل فترة الرحلة. بعض الجهات تطلب تغطيات محددة." },
    { title: "هوية وطنية/مستندات عائلية", desc: "صورة الهوية وكرت العائلة، وقد تُطلب ترجمة معتمدة." },
  ];

  const steps = [
    { label: "اختيار نوع التأشيرة", tip: "سياحية/عمل/دراسة… تختلف معها المتطلبات." },
    { label: "تجهيز الوثائق", tip: "راجعي المتطلبات العامة وتعليمات السفارة لأي شروط إضافية." },
    { label: "حجز موعد/نموذج", tip: "عبر موقع السفارة أو مركز التأشيرات (VFS/…)." },
    { label: "التقديم والبصمة", tip: "سداد الرسوم، تسليم الملفات، وبصمة إن لزم." },
    { label: "تتبع المعاملة", tip: "احتفظي بإيصال التقديم وتابعي الحالة على الموقع." },
    { label: "استلام الجواز", tip: "تحققي من صحة بيانات التأشيرة قبل السفر." },
  ];



  return (
    <main className="container py-4" style={{ direction: "rtl" }}>
      {/* HERO */}
      <section className="visa-hero rounded-4 p-4 p-lg-5 mb-4 text-white position-relative overflow-hidden">
        {/* زخرفة بسيطة */}
        <div className="visa-hero-ornament" aria-hidden />
        <h1 className="display-6 display-md-5 fw-bold mb-2">متطلبات التأشيرات — دليل عام</h1>
        <p className="lead mb-0 opacity-90">
          نظرة شاملة على أهم الوثائق والخطوات الشائعة لمعظم أنواع التأشيرات، بدون الارتباط بدولة معيّنة.
        </p>
        <div className="d-flex gap-2 mt-3">
          <a href="#checklist" className="btn btn-brand rounded-pill px-4">ابدئي الترتيب</a>
          <a href="#faq" className="btn btn-outline-light rounded-pill px-4">الأسئلة الشائعة</a>
        </div>
      </section>

      {/* Highlights */}
      <section className="mb-4">
        <div className="row g-3">
          {["جواز صالح", "صور مطابقة", "تعريف بالراتب", "كشف حساب", "تأمين سفر", "هوية/عائلة"].map((t, i) => (
            <div className="col-6 col-md-4 col-lg-2" key={i}>
              <div className="feature-tile border rounded-4 p-3 h-100 text-center bg-light">
                <div className="fs-3 mb-2" aria-hidden>
                  {["🛂", "🖼️", "🧾", "🏦", "🛡️", "🪪"][i]}
                </div>
                <div className="small fw-semibold">{t}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Checklist */}
      <section id="checklist" className="mb-5">
        <div className="row g-4">
          {checklist.map((item, i) => (
            <div className="col-md-6" key={i}>
              <div className="card-checklist border rounded-4 p-4 h-100">
                <div className="d-flex align-items-start gap-3">
                  <div className="check-badge" aria-hidden>✓</div>
                  <div>
                    <h3 className="h6 fw-bold mb-1">{item.title}</h3>
                    <p className="mb-0 text-muted small">{item.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Notes */}
      <section className="mb-5">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="border rounded-4 p-4 h-100 bg-white">
              <h3 className="h6 fw-bold mb-2">ملاحظات عامة للمتقدمين</h3>
              <ul className="small text-muted mb-0 pe-3" style={{ lineHeight: 1.9 }}>
                <li>احرصي أن تكون المستندات حديثة ومختومة رسميًا حيث يلزم.</li>
                <li>تطابق الأسماء والتواريخ بين الجواز وبقية المستندات.</li>
                <li>رتّبي الأوراق حسب التسلسل المطلوب لتسريع المراجعة.</li>
                <li>احتفظي بنسخ إلكترونية (PDF/صور) من كل مستند للرجوع السريع.</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="border rounded-4 p-4 h-100 bg-white">
              <h3 className="h6 fw-bold mb-2">حالات خاصة</h3>
              <ul className="small text-muted mb-0 pe-3" style={{ lineHeight: 1.9 }}>
                <li>غير المواطنين: قد تُطلب إقامة سارية، وصور من تأشيرات خروج/عودة، وكشف حساب أطول.</li>
                <li>جواز دبلوماسي/خاص: آلية مختلفة (توصية من الخارجية مثلاً) وقد لا يُطلب كشف حساب.</li>
                <li>طلاب/أعمال: قد تُطلب قبولات دراسية/دعوات عمل/معارض أو خطاب جهة مضيفة.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Steps */}
      <section className="mb-5">
        <h3 className="h5 fw-bold mb-3">خطوات التقديم المختصرة</h3>
        <ol className="timeline list-unstyled m-0">
          {steps.map((s, i) => (
            <li key={i} className="timeline-item">
              <div className="timeline-dot" aria-hidden />
              <div className="timeline-content">
                <div className="fw-semibold">{s.label}</div>
                <small className="text-muted">{s.tip}</small>
              </div>
            </li>
          ))}
        </ol>
      </section>

      {/* FAQ */}


      {/* CTA */}
      <section className="mb-4">
        <div className="border rounded-4 p-4 p-md-5 text-center bg-light">
          <h3 className="h5 fw-bold mb-2">جاهزة تبدأي؟</h3>
          <p className="text-muted small mb-3">
            احجزي موعدًا، أو تواصلي معنا لمراجعة أوراقك قبل التقديم. إحنا معاكِ خطوة بخطوة.
          </p>
          <div className="d-flex gap-2 justify-content-center">
            <Link to="/contact" className="btn btn-brand rounded-pill px-4"   onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>ابدئي الطلب</Link>
            <Link to="/contact" className="btn btn-outline-brand rounded-pill px-4"   onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>تواصل معنا</Link>
          </div>
        </div>
        <p className="text-muted small mt-3 mb-0">
          ⚠️ قد تتغير المتطلبات حسب تعليمات السفارات ومراكز التأشيرات. راجعي دائمًا المصادر الرسمية قبل التقديم.
        </p>
      </section>
    </main>
  );
}
